import {
  Ac,
  Attention,
  Beach,
  Bed,
  Cake,
  CalendarClock,
  CardTravel,
  Cars,
  Casino,
  Chat,
  Cruises,
  Discount,
  Dollar,
  DollarCircle,
  EarlyBird,
  Email,
  Event,
  Flights,
  Help,
  Hotels,
  Information,
  InformationOutline,
  Lock,
  Loyalty,
  Luggage,
  Sparkle,
  Star,
  Success,
  SuccessOutline,
  Sunrise,
  TravelExplore,
  Verified,
  Warning,
  WarningOutline,
} from 'pcln-icons'

const ICONS = {
  Ac,
  Attention,
  Beach,
  Bed,
  Cake,
  CalendarClock,
  CardTravel,
  Cars,
  Casino,
  Chat,
  Cruises,
  Discount,
  Dollar,
  DollarCircle,
  EarlyBird,
  Email,
  Event,
  Flights,
  Help,
  Hotels,
  Information,
  InformationOutline,
  Lock,
  Loyalty,
  Luggage,
  Sparkle,
  Star,
  Success,
  SuccessOutline,
  Sunrise,
  TravelExplore,
  Verified,
  Warning,
  WarningOutline,
}

export default ICONS
